<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <soil-field-form-groups
        :submission="submission_data"
        :index="index"
        @onFieldChange="onFieldChange"
      ></soil-field-form-groups>
      <div v-if="submission_data.samples && submission_data.samples.length">
        <hr />
        <template v-for="(sample, sampleIndex) in submission_data.samples">
          <soil-sample-form-group
            :key="sampleIndex"
            :sample="sample"
            :index="sampleIndex"
            :addOns="addOns"
            :allTestPackages="allTestPackages"
            @onSampleChange="onSampleChange"
          ></soil-sample-form-group>
        </template>
      </div>
      <hr />
      <soil-next-crop-form-groups
        :submission="submission_data"
        :index="index"
        @onNextCropChange="onNextCropChange"
      ></soil-next-crop-form-groups>
      <div v-if="turnArounds && turnArounds.models.length">
        <hr />
        <turn-around-select
          :turnArounds="turnArounds"
          :selectedTurnAround="submission_data.turnaround"
          @onTurnAroundSelect="onTurnAroundSelect"
        ></turn-around-select>
      </div>
      <div v-if="serviceQuestions && serviceQuestions.models.length">
        <hr />
        <service-question
          v-for="(serviceQuestion, index) in serviceQuestions.models"
          :serviceQuestion="serviceQuestion"
          :key="index"
        ></service-question>
      </div>
      <b-button variant="danger" @click="removeSubmission"
        ><i class="fal fa-trash"></i
      ></b-button>
    </b-card>
  </div>
</template>

<script>
import SoilFieldFormGroups from "./SoilFieldFormGroups";
import SoilSampleFormGroups from "./SoilSampleFormGroups";
import SoilSampleFormGroup from "./SoilSampleFormGroup";
import SoilNextCropFormGroups from "./SoilNextCropFormGroups";
import TurnAroundSelect from "../../TurnAroundSelect";
import ServiceQuestion from "../../ServiceQuestion";
import TestPackageSampleCollection from "../../../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../../../collections/lab/TestPackageCollection";
import TurnaroundCollection from "../../../../collections/lab/TurnaroundCollection";
import ServiceQuestionCollection from "../../../../collections/lab/ServiceQuestionCollection";

export default {
  name: "FieldSoilForm",
  components: {
    TurnAroundSelect,
    SoilNextCropFormGroups,
    SoilSampleFormGroup,
    SoilSampleFormGroups,
    SoilFieldFormGroups,
    ServiceQuestion
  },
  props: {
    submission: {
      type: Object,
      default: () => null
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    index: {
      type: Number,
      default: null
    },
    serviceQuestions: {
      type: Object,
      default: () => new ServiceQuestionCollection()
    },
    allTestPackages: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      submission_data: null
    };
  },
  computed: {},
  methods: {
    onFieldChange(data) {
      if (data) {
        this.submission_data.submission_soil.grower = data.grower;
        this.submission_data.identifier = data.identifier;
        this.submission_data.event_code = data.event_code;
        this.submission_data.submission_soil.irrigated = data.irrigated;

        if (data.customer_grower_id) {
          this.submission_data.submission_soil.customer_grower_id = data.customer_grower_id
        }

        if (data.customer_field_id) {
          this.submission_data.submission_soil.customer_field_id = data.customer_field_id
        }
        this.emitSubmissionChange();
      }
    },
    onSampleChange(params) {
      if (params) {
        let sample = params.sample;
        let index = params.index;
        if (
          this.submission_data.samples &&
          this.submission_data.samples.length &&
          sample &&
          index !== null
        ) {
          this.submission_data.samples.splice(index, 1, sample);
          this.emitSubmissionChange();
        }
      }
    },
    onNextCropChange(projections) {
      if (projections) {
        this.submission_data.submission_soil.projections = projections;
        this.emitSubmissionChange();
      }
    },
    emitSubmissionChange() {
      this.$emit("onSubmissionChange", {
        submission: this.submission_data,
        index: this.index
      });
    },
    removeSubmission() {
      this.$emit("removeSubmission", this.index);
    },
    onTurnAroundSelect(turnaround) {
      if (turnaround && turnaround.id) {
        this.submission_data.turnaround = turnaround;
        this.submission_data.turnaround_id = turnaround.id;
        this.emitSubmissionChange();
      } else {
        this.submission_data.turnaround = null;
        this.submission_data.turnaround_id = null;
        this.emitSubmissionChange();
      }
    }
  },
  watch: {
    form: {
      handler() {
        this.emitSubmissionChange();
      },
      deep: true
    },
    submission: {
      handler(value) {
        this.submission_data = value;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.submission) {
      this.submission_data = this.submission;
    }
  }
};
</script>
